// 任务配置
export default {
    siteManagement: '站点管理',
    siteName: '站点名',
    addSite: '添加站点',
    tip_enterSiteName: '请输入站点名',
}